import {Button} from "antd";
import React from "react";
import {PdfSVG} from "assets";
import "./ButtonPdf.scss";
const ButtonPdf = props => {
  const {onClick, disabled, title = "Xuất báo cáo"} = props;
  return (
    <Button className="btn-pdf" onClick={onClick} disabled={disabled}>
      <PdfSVG style={{width: 20}} />
      {title}
    </Button>
  );
};
export default ButtonPdf;
